module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Lamp1-5fbc03a35fef4caaf960d0a932616656.svg";